module.exports = __webpack_public_path__ + "img/first-canadian-platinum-shield-stock.3d4e80dd.jpeg";